import { memo } from 'react';

import styled from 'styled-components';

import { IconFormIndicatorLocked } from '@components/icons/form-indicator-locked';
import { IconUpload } from '@components/icons/upload';
import { theme } from '@styles/theme';
import { transitionStandard } from '@utils/transitions';

type FileInputContentProps = {
  onClick?(): void;
  error?: string;
  placeholder?: string;
  isDisabled?: boolean;
};

export const FileInputContent = memo<FileInputContentProps>(
  ({ onClick, error, placeholder, isDisabled = false }) => {
    return (
      <Container data-error={Boolean(error)} data-disabled={isDisabled} onClick={onClick}>
        <IconUpload />
        <span data-placeholder="true">{placeholder}</span>
        {isDisabled && <IconFormIndicatorLocked />}
      </Container>
    );
  },
);

const Container = styled.button.attrs({
  type: 'button',
})({
  background: theme.form.bg.color,
  padding: '0 0.5rem',
  height: theme.base.height,
  gap: '0.5rem',
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  borderStyle: 'solid',
  borderRadius: theme.form.border.radius,
  borderWidth: theme.form.border.width,
  borderColor: theme.form.border.color,
  font: theme.font.regular16,

  '&[data-error="true"]': {
    borderColor: theme.color.error,
  },

  '[data-placeholder="true"]': {
    color: theme.form.placeholder.color,
    textAlign: 'left',
    flexGrow: 1,
  },

  svg: {
    transition: transitionStandard('color'),
    color: theme.form.icon.color,
    flexShrink: 0,
  },

  '&[data-disabled="false"]': {
    cursor: 'pointer',

    '&:hover': {
      background: theme.form.bg.colorHover,
    },

    '&:focus-visible': {
      background: theme.form.bg.colorFocus,
      borderColor: theme.form.border.colorFocus,

      '[data-placeholder="true"]': {
        color: theme.form.placeholder.colorFocus,
      },

      '[data-file-value="true"]': {
        color: theme.form.value.colorFocus,
      },

      svg: {
        color: theme.form.icon.colorFocus,
      },
    },
  },
});
